require('./mortgageRequestAppraisalRequestConfirmationData.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;
const Immutable = require('immutable');

// @ constants
const { PLURAL_CHARACTER } = require('constants/index');
const { SECOND_STEP, EURO_TEXT } = require('constants/index');
const { ESTATES_TYPE_ABBREVIATION } = require('constants/mortgageRequestEstates');
const { INDIFFERENT, MORNING, LATE } = require('constants/mortgageRequestAppraisalRequest').SCHEDULE_OPTIONS;

// @ commons
const DateHelper = require('utilities/dateHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestFormattedAddress = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');
const MortgageRequestAnnexConstructions = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestAnnexConstructions/mortgageRequestAnnexConstructions');

class MortgageRequestAppraisalRequestConfirmationData extends React.Component {
    getSelectedAccount() {
        const { immAppraisalRequest, immAccounts } = this.props;
        const accountId = immAppraisalRequest.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', accountId], '');

        return {
            accountNumber: immAccount.get('iban'),
            accountType: immAccount.getIn(['catalogData', 'product']),
        }
    }

    buildAddressContent(immEstate) {
        return (
            <OKInformativeListItem
                title="mortgageRequestAppraisalRequest-step1LivingPlace"
                compact={true}
            >
                <MortgageRequestFormattedAddress
                    immEstate={immEstate}
                    className="mortgage-request-appraisal-request-step-one__text"
                />
            </OKInformativeListItem>
        );
    }

    buildAppraisalVisitContent(visitData) {
        const appraisalVisit = visitData.get('appraisalVisit');
        const appraisalVisitDate = visitData.get('appraisalVisitDate') || '';
        const appraisalVisitDateFormated = appraisalVisitDate !== '' ? DateHelper.buildFormattedDate(appraisalVisitDate, 'DD MMM YYYY') : '';
        const appraisalSchedule = visitData.get('appraisalSchedule') || '';
        const attendanceText = formatText('mortgageRequestAppraisalRequest-appraisalRequestConfirmationAssist');
        const noAttendanceText = formatText('mortgageRequestAppraisalRequest-appraisalRequestConfirmationNoAssist');
        const appraisalVisitText = appraisalVisit ? attendanceText : noAttendanceText;

        let content;
        let scheduleText;

        if (appraisalVisit && appraisalVisitDate !== '') {
            if (appraisalSchedule === MORNING) {
                scheduleText = formatText('mortgageRequestAppraisalRequest-appraiserVisitScheduleOption1');
            } else if (appraisalSchedule === LATE) {
                scheduleText = formatText('mortgageRequestAppraisalRequest-appraiserVisitScheduleOption2');
            } else if (appraisalSchedule === INDIFFERENT) {
                scheduleText = formatText('mortgageRequestAppraisalRequest-appraiserVisitScheduleOption0');
            }

            content = (
                <OKInformativeList>
                    <OKInformativeListItem
                        title="mortgageRequestAppraisalRequest-appraisalRequestConfirmationVisitDate"
                        compact={true}
                        className="mortgage-request-appraisal-confirmation-container__visit-data"
                    >
                        <div className="mortgage-request-appraisal-confirmation-container__visit-data-content">
                            <span className="mortgage-request-appraisal-confirmation-container__visit-text">{appraisalVisitDateFormated}</span>
                            <span className="mortgage-request-appraisal-confirmation-container__visit-text">{scheduleText}</span>
                            <span className="mortgage-request-appraisal-confirmation-container__visit-text">{appraisalVisitText}</span>
                        </div>
                    </OKInformativeListItem>
                </OKInformativeList>
            )
        } else {
            content = (
                <OKInformativeList>
                    <OKInformativeListItem
                        title="mortgageRequestAppraisalRequest-appraisalRequestConfirmationVisitDate"
                        compact={true}
                    >
                        <span className="mortgage-request-appraisal-confirmation-container__text">{appraisalVisitText}</span>
                    </OKInformativeListItem>
                </OKInformativeList>
            )
        }

        return content;
    }

    buildIncludeImmsData(livingPlaceData) {
        const totalStorageRooms = parseInt(livingPlaceData.get('storageRooms'), 0);
        const totalGarages = parseInt(livingPlaceData.get('garages'), 0);

        let includeImmsData;

        if (totalStorageRooms > 0 || totalGarages > 0) {
            const storageRoomsContent = this.storagesRoomInformation(totalStorageRooms);
            const garagesContent = this.garagesInformation(totalGarages);

            let title;
            let includeConnector = '';

            if (totalStorageRooms > 0 && totalGarages > 0) {
                includeConnector = formatText('mortgageRequestAppraisalRequest-step1IncludeConnector');
            }

            title = formatText('mortgageRequestAppraisalRequest-step1Include', [storageRoomsContent, includeConnector, garagesContent]);

            includeImmsData = (
                <OKInformativeListItem title={title} />
            )
        }

        return includeImmsData;
    }

    buildLivingPlaceContentInformation(livingPlace) {
        const { immEstates } = this.props;
        const { accountData, appraisalRequestCost } = livingPlace;

        const accountType = accountData.accountType.toLowerCase();
        const accountLastNumbers = getLastNChars(accountData.accountNumber.toString());
        const appraisalCostParams = {
            currency: appraisalRequestCost,
            symbol: EURO_TEXT
        };
        const appraisalRequestTotalCost = MortgageRequestCurrencyHelp(appraisalCostParams);

        let livingPlaceInformation = immEstates.get('list').find(immEstate => immEstate.get('propertyType') === ESTATES_TYPE_ABBREVIATION.VIVIENDA);
        let livingPlaceAddress;
        let includeImmsInformation;

        if (livingPlaceInformation) {
            livingPlaceAddress = this.buildAddressContent(livingPlaceInformation);
            includeImmsInformation = this.buildIncludeImmsData(livingPlaceInformation);
        }

        return (
            <OKInformativeList columns={2}>
                {livingPlaceAddress}
                <OKInformativeListItem
                    title="mortgageRequestAppraisalRequest-appraisalRequestConfirmationAppraisalCost"
                    compact={true}
                >
                    <span className="mortgage-request-appraisal-confirmation-container__text">{appraisalRequestTotalCost}</span>
                </OKInformativeListItem>
                {includeImmsInformation}
                <OKInformativeListItem
                    title="mortgageRequestAppraisalRequest-appraisalRequestConfirmationAccountLabel"
                    compact={true}
                >
                    <span className="mortgage-request-appraisal-confirmation-container__value">{accountType} {accountLastNumbers}</span>
                </OKInformativeListItem>
            </OKInformativeList>
        )
    }

    garagesInformation(totalGarages) {
        let garagesContent = '';

        if (totalGarages > 0) {
            const garagesTotalText = totalGarages !== 1 ? PLURAL_CHARACTER : '';
            garagesContent = formatText('mortgageRequestAppraisalRequest-step1Garages', [totalGarages, garagesTotalText]);
        }

        return garagesContent;
    }

    storagesRoomInformation(totalStorageRooms) {
        let storageRoomsContent = '';

        if (totalStorageRooms > 0) {
            const storageRoomsTotalText = totalStorageRooms !== 1 ? PLURAL_CHARACTER : '';
            storageRoomsContent = formatText('mortgageRequestAppraisalRequest-step1StorageRoom', [totalStorageRooms, storageRoomsTotalText]);
        }

        return storageRoomsContent;
    }

    render() {
        const { immEstates, immPayment, immAppraisalRequest } = this.props;

        const accountData = this.getSelectedAccount();
        const appraisalRequestCost = immPayment.get('appraisalCost');
        const appraisalVisitData = immAppraisalRequest.get('visitData');
        const immAnnexConstructions = Immutable.fromJS(immEstates.get('list').reduce((annexContructions, immEstate) => {
            if (immEstate.get('propertyType') !== ESTATES_TYPE_ABBREVIATION.VIVIENDA) {
                annexContructions.push(immEstate);
            }

            return annexContructions;
        }, []));

        const livingPlaceInformation = {
            accountData,
            appraisalRequestCost,
        };

        return (
            <div className="mortgage-request-appraisal-confirmation-container">
                {this.buildLivingPlaceContentInformation(livingPlaceInformation)}
                <div className="mortgage-request-appraisal-confirmation-container__additional">
                    <MortgageRequestAnnexConstructions immAnnexConstructions={immAnnexConstructions} />
                </div>

                <div className="mortgage-request-appraisal-confirmation-container__visit-information">
                    {this.buildAppraisalVisitContent(appraisalVisitData)}
                </div>
            </div >
        )
    }
}


MortgageRequestAppraisalRequestConfirmationData.propTypes = {
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAppraisalRequest: PropTypes.object.isRequired
};

module.exports = MortgageRequestAppraisalRequestConfirmationData;